import { createStore } from "vuex";
import system from "./modules/system";
export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    system,
  },
});
